import React from 'react';
import { Group, HoverCard, Text, UnstyledButton } from '@mantine/core';
import { IconInfoCircle } from '@tabler/icons-react';
import { PropagationStopper } from '../../components/common';
import { SuggestedPriceFormulaContent } from './proposed-selling-formula/SuggestedPriceFormulaContent';

export function ProposedSellingColumnHeader() {
    return (
        <Group gap="xs" wrap="nowrap" className="text-white">
            <Text size="sm" fw={500}>
                Proposed Selling Price
            </Text>
            <HoverCard
                withArrow
                arrowOffset={6}
                arrowSize={10}
                position="left"
                offset={10}
                withinPortal
                floatingStrategy="fixed"
                middlewares={{ flip: true, shift: true, size: true }}
                shadow="md"
                zIndex={400}
                openDelay={200}
                closeDelay={400}
                transitionProps={{
                    transition: 'scale',
                    duration: 200,
                }}
                classNames={{
                    dropdown:
                        'rounded-xl p-0 border border-gray-200 bg-white shadow-md max-w-[min(100vw-2rem,22rem)]',
                    arrow: '!border-[var(--mantine-color-gray-3)]',
                }}
            >
                <HoverCard.Target>
                    <PropagationStopper>
                        <UnstyledButton
                            aria-label="Suggested price formula"
                            className="flex shrink-0 cursor-help items-center opacity-90 hover:opacity-100"
                        >
                            <IconInfoCircle size={16} className="text-white" />
                        </UnstyledButton>
                    </PropagationStopper>
                </HoverCard.Target>
                <HoverCard.Dropdown>
                    <SuggestedPriceFormulaContent />
                </HoverCard.Dropdown>
            </HoverCard>
        </Group>
    );
}
